import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PartitionedEventListenerBase } from 'app/calendar/event_listener_base';
import { Config } from 'app/config.const';
import { Agende } from 'app/model/agende';
import { IAppuntamento } from 'app/model/appuntamento';
import * as moment from 'moment';
import { isFunction } from 'util';
import { OAuth2Service } from '../../angular-rest';

@Component({
	selector: 'app-sala-attesa',
	templateUrl: './sala_attesa.html',
	styleUrls: ['./sala_attesa.css']
})
export class SalaAttesaComponent extends PartitionedEventListenerBase<string> {
	public today: moment.Moment;
	
	get height() {
		if (isFunction(Config.defaultCalendarOptions.height)) {
			return (<() => number><any>Config.defaultCalendarOptions.height)();
		} else {
			return Config.defaultCalendarOptions.height;
		}
	}

	constructor(route: ActivatedRoute, agende: Agende, router: Router, auther: OAuth2Service) {
		super(
			route, 
			agende, 
			router, 
			auther,
			appuntamento => appuntamento.evento === 'Visita ambulatoriale'
		);
		moment.locale('it');
		this.today = moment();
	}

	protected getPartitionKeys(appuntamento: IAppuntamento): string[] {
		return [ appuntamento.status ];
	}

	public updateStatus(appuntamento: IAppuntamento, status: string) {
		this.upsertEvent($.extend({}, appuntamento, { status, version: +appuntamento.version + 1 }));
	}
}




// WEBPACK FOOTER //
// ./src/app/calendar/sala-attesa/sala_attesa.ts